import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { ApiResponse, ErrorResponse } from '../../types/api.types';

export class BaseApiService {
    protected axios: AxiosInstance;

    constructor(axiosInstance: AxiosInstance) {
        this.axios = axiosInstance;
    }

    protected async get<T>(url: string, config?: AxiosRequestConfig): Promise<ApiResponse<T>> {
        try {
            const response = await this.axios.get<ApiResponse<T>>(url, config);
            return response.data;
        } catch (error) {
            this.handleError(error as Error);
            throw error;
        }
    }

    protected async post<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<ApiResponse<T>> {
        try {
            const response = await this.axios.post<ApiResponse<T>>(url, data, config);
            return response.data;
        } catch (error) {
            this.handleError(error as Error);
            throw error;
        }
    }

    protected async put<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<ApiResponse<T>> {
        try {
            const response = await this.axios.put<ApiResponse<T>>(url, data, config);
            return response.data;
        } catch (error) {
            this.handleError(error as Error);
            throw error;
        }
    }

    protected async patch<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<ApiResponse<T>> {
        try {
            const response = await this.axios.patch<ApiResponse<T>>(url, data, config);
            return response.data;
        } catch (error) {
            this.handleError(error as Error);
            throw error;
        }
    }

    protected async delete<T>(url: string, config?: AxiosRequestConfig): Promise<ApiResponse<T>> {
        try {
            const response = await this.axios.delete<ApiResponse<T>>(url, config);
            return response.data;
        } catch (error) {
            this.handleError(error as Error);
            throw error;
        }
    }

    protected handleError(error: Error): void {
        console.error('API Error:', error);

        if (axios.isAxiosError(error)) {
            const errorResponse = error.response?.data as ErrorResponse;
            console.log(errorResponse);
            switch (error.response?.status) {
                case 400:
                    // Handle bad request
                    break;
                case 403:
                    // Handle forbidden
                    break;
                case 404:
                    // Handle not found
                    break;
                case 500:
                    // Handle server error
                    break;
                default:
                    // Handle other errors
                    break;
            }
        }
    }
}